export default "__VITE_ASSET__s4QNMg1T__"